import { isDefined } from '@aloft/toolkit-shared';

import { get } from 'lodash';

import {
  BreakdownColumn,
  ColumnDataExtractionDefinition,
  CombinedColumn,
  Tkv2PairedCostSummaryInterfaceV2,
  isCombinedColumn,
  isSingleColumn,
} from '../types.ts';
import { getPropertyFromSummary } from './getPropertyFromSummary.ts';

function getValueForSingleColumn<T extends 'feature' | 'adjustment'>(
  summary: Tkv2PairedCostSummaryInterfaceV2,
  id: string,
  column: ColumnDataExtractionDefinition<T>,
) {
  const property = getPropertyFromSummary(summary, id, column);
  const { path } = column;

  return isDefined(property) ? get(property, path) : undefined;
}

function getValueForCombinedColumn(
  summary: Tkv2PairedCostSummaryInterfaceV2,
  id: string,
  column: CombinedColumn,
) {
  const { columns, combiner } = column;
  const values = columns.map((col) => {
    return getValueForSingleColumn(summary, id, col);
  });

  return combiner(values);
}

export function getValueForColumn(
  summary: Tkv2PairedCostSummaryInterfaceV2,
  id: string,
  column: BreakdownColumn,
) {
  if (isSingleColumn(column)) {
    return getValueForSingleColumn(summary, id, column);
  }
  if (isCombinedColumn(column)) {
    return getValueForCombinedColumn(summary, id, column);
  }
  return undefined;
}
